import { Alert } from '@gogame/components';

export default () => {
  return (
    <Alert severity={'warning'}>
      Please be sure to review the email address from which the invoice was sent
      and the data in the attached invoice carefully. If the email address looks
      suspicious or characters in the invoice (for example, a partner name) look
      like a piece of a code, be sure to Delete the invoice.
    </Alert>
  );
};
